import React from "react";
import Select from "react-select";

const SelectTaxtSystem = (props) => {
  const options = [
    {
      isDisabled: false,
      label: "601 - General de Ley Personas Morales",
      value: "601",
    },
    {
      isDisabled: false,
      label: "626 - Régimen Simplificado de Confianza",
      value: "626",
    },
    {
      isDisabled: false,
      label:
        "612 - Personas Físicas con Actividades Empresariales y Profesionales",
      value: "612",
    },
    { isDisabled: false, label: "621 - Incorporación Fiscal", value: "621" },
    {
      isDisabled: false,
      label: "616 - Sin obligaciones fiscales",
      value: "616",
    },
    {
      isDisabled: false,
      label:
        "625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas",
      value: "625",
    },
    // {
    //   isDisabled: true,
    //   label: "603 - Personas Morales con Fines no Lucrativos",
    //   value: "603",
    // },
    // {
    //   isDisabled: true,
    //   label: "605 - Sueldos y Salarios e Ingresos Asimilados a Salarios",
    //   value: "605",
    // },
    // { isDisabled: true, label: "606 - Arrendamiento", value: "606" },
    // { isDisabled: true, label: "608 - Demás ingresos", value: "608" },
    // { isDisabled: true, label: "609 - Consolidación", value: "609" },
    // {
    //   isDisabled: true,
    //   label:
    //     "610 - Residentes en el Extranjero sin Establecimiento Permanente en México",
    //   value: "610",
    // },
    // {
    //   isDisabled: true,
    //   label: "611 - Ingresos por Dividendos (socios y accionistas)",
    //   value: "611",
    // },
    // { isDisabled: true, label: "614 - Ingresos por intereses", value: "614" },
    // {
    //   isDisabled: true,
    //   label:
    //     "620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos",
    //   value: "620",
    // },
    // {
    //   isDisabled: true,
    //   label: "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras",
    //   value: "622",
    // },
    // {
    //   isDisabled: true,
    //   label: "623 - Opcional para Grupos de Sociedades",
    //   value: "623",
    // },
    // { isDisabled: true, label: "624 - Coordinados", value: "624" },
    // { isDisabled: true, label: "628 - Hidrocarburos", value: "628" },
    // {
    //   isDisabled: true,
    //   label: "607 - Régimen de Enajenación o Adquisición de Bienes",
    //   value: "607",
    // },
    // {
    //   isDisabled: true,
    //   label:
    //     "629 - De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales",
    //   value: "629",
    // },
    // {
    //   isDisabled: true,
    //   label: "630 - Enajenación de acciones en bolsa de valores",
    //   value: "630",
    // },
    // {
    //   isDisabled: true,
    //   label: "615 - Régimen de los ingresos por obtención de premios",
    //   value: "615",
    // },
  ];

  const detectarCambiosTaxtSystem = (selectedOption) => {
    props.detectarCambiosTaxtSystem(selectedOption);
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
  };

  return (
    <Select
      required
      options={options}
      value={props.selectedOption}
      onChange={detectarCambiosTaxtSystem}
      placeholder="Selecciona el Régimen Fiscal"
      styles={selectStyles}
    />
  );
};

export default SelectTaxtSystem;
